import { Injectable } from '@angular/core';
import { TileIpeGaugeComponent } from '../../../components/tile/tile-ipe-gauge/tile-ipe-gauge';
import type { CustomTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileIpeGaugeProvider implements CustomTileProvider {
    fillTileDescription(): CustomTileModel {
        throw Error('Not implemented');
    }

    getTileComponent() {
        return TileIpeGaugeComponent;
    }
}
